/*
 * Stensaga GA4 custom events. Source of truth: /home/vps/stensaga-ga4/theme (keep in sync with ga4_config.py).
 *
 * Sends through the Google & YouTube app's gtag, which Shopify only loads after cookie consent: no consent, no
 * gtag, nothing sent. Events fired before gtag exists wait up to 15 s, then are dropped.
 *
 * EVENTS (params; every event also gets page_type):
 *   guide_link_click         (sent from the next page) guide_slug, link_type (product|collection|guide|other), link_target, product_handle
 *   promo_click              (sent from the next page) promo_name (hero|paket|announcement), link_target
 *   waitlist_signup          product_handle, form_location=waitlist      (key event, fired after the success page)
 *   newsletter_signup        form_location (nyhetsbrev|popup|footer)     (key event, fired after the success page)
 *   contact_submit           form_location=contact                       (key event, fired after the success page)
 *   accordion_open           accordion_title
 *   collection_filter        filter_name, filter_value
 *   gift_card_amount_select  gift_amount
 */
(function () {
  'use strict';
  var cfg = window.stensagaAnalytics || {};
  var queue = [];
  var waited = 0;

  function track(name, params) {
    var p = Object.assign({ page_type: cfg.pageType || 'other', send_to: cfg.id }, params || {});
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, p);
    } else {
      queue.push([name, p]);
      if (queue.length === 1) flushLater();
    }
  }

  function flushLater() {
    setTimeout(function () {
      waited += 500;
      if (typeof window.gtag === 'function') {
        queue.splice(0).forEach(function (e) { window.gtag('event', e[0], e[1]); });
        waited = 0;
      } else if (waited < 15000) {
        flushLater();
      } else {
        queue.length = 0;
        waited = 0;
      }
    }, 500);
  }

  function path(a) {
    try {
      var u = new URL(a.href, location.href);
      return u.origin === location.origin ? u.pathname : null;
    } catch (e) {
      return null;
    }
  }

  function store(fn) {
    try { return fn(window.sessionStorage); } catch (e) { return null; }
  }

  // Internal link clicks navigate away before gtag's batch is out, so they are handed to the next page in this tab
  // (sessionStorage) and sent from there. New-tab clicks keep this page alive and are sent right away.
  var NEXT = 'sg_ga4_next';
  function trackOnNextPage(e, a, name, params) {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1 || a.target === '_blank' || e.defaultPrevented) {
      return track(name, params);
    }
    store(function (s) {
      var list = JSON.parse(s.getItem(NEXT) || '[]');
      list.push({ e: name, p: Object.assign({ page_type: cfg.pageType || 'other' }, params), t: Date.now() });
      s.setItem(NEXT, JSON.stringify(list.slice(-5)));
    });
  }
  function flushNext() {
    var raw = store(function (s) { var v = s.getItem(NEXT); s.removeItem(NEXT); return v; });
    var list;
    try { list = JSON.parse(raw || '[]'); } catch (e) { list = []; }
    list.forEach(function (x) {
      if (x && x.e && Date.now() - x.t < 10 * 60 * 1000) track(x.e, x.p);
    });
  }

  function inChrome(el) {
    return !!el.closest('header, footer, nav, .header, .footer, cart-drawer, .cart-drawer, .facets');
  }

  // --- link clicks: guide -> product/collection/guide, homepage promo areas ---------------------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var p = path(a);
    if (!p) return;

    if (cfg.pageType === 'guide' && a.closest('main') && !inChrome(a)) {
      var m = p.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(products|collections|blogs\/stenguide)\/([^/?#]+)/);
      var type = m ? { products: 'product', collections: 'collection', 'blogs/stenguide': 'guide' }[m[1]] : 'other';
      trackOnNextPage(e, a, 'guide_link_click', {
        guide_slug: cfg.guide,
        link_type: type,
        link_target: p,
        product_handle: type === 'product' ? m[2] : undefined
      });
    }

    var sec = a.closest('.shopify-section, [id^="shopify-section-"]');
    var sid = sec ? (sec.id || '') : '';
    var promo = (sid.match(/announcement|hero|paket/i) || [])[0];
    if (promo) trackOnNextPage(e, a, 'promo_click', { promo_name: promo.toLowerCase(), link_target: p });
  }, true);

  // --- forms: remember the submit, fire the event once the success state renders (after redirect/captcha) ----
  var PENDING = 'sg_ga4_pending';
  var SUCCESS = {
    waitlist_signup: '.waitlist__success',
    newsletter_signup: '.nl-offer__success, [id^="Email-signup__message-success"]',
    contact_submit: '.contact-form__success'
  };

  function formEvent(f) {
    var id = f.id || '';
    if (id.indexOf('WaitlistForm-') === 0) {
      return ['waitlist_signup', { form_location: 'waitlist', product_handle: cfg.product || undefined }];
    }
    if (id === 'nyhetsbrev') return ['newsletter_signup', { form_location: 'nyhetsbrev' }];
    if (id === 'nyhetsbrev-popup') return ['newsletter_signup', { form_location: 'popup' }];
    if (f.classList.contains('email-signup__form')) return ['newsletter_signup', { form_location: 'footer' }];
    if (f.classList.contains('contact-form__form')) return ['contact_submit', { form_location: 'contact' }];
    return null;
  }

  document.addEventListener('submit', function (e) {
    var ev = e.target && e.target.tagName === 'FORM' ? formEvent(e.target) : null;
    if (!ev) return;
    store(function (s) { s.setItem(PENDING, JSON.stringify({ e: ev[0], p: ev[1], t: Date.now() })); });
  }, true);

  function checkPending() {
    var raw = store(function (s) { return s.getItem(PENDING); });
    if (!raw) return;
    var x;
    try { x = JSON.parse(raw); } catch (e) { x = null; }
    var done = function () { store(function (s) { s.removeItem(PENDING); }); };
    if (!x || !SUCCESS[x.e] || Date.now() - x.t > 15 * 60 * 1000) return done();
    if (document.querySelector(SUCCESS[x.e])) {
      track(x.e, x.p);
      done();
    }
    // else: an intermediate page (e.g. /challenge captcha): keep waiting until the success page or expiry.
  }

  // --- accordions / FAQ -------------------------------------------------------------------------------------
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || inChrome(d)) return;
    if (!d.closest('main') || d.closest('.facets, [class*="filter"], [class*="sorting"], .menu, cart-items')) return;
    var s = d.querySelector('summary');
    var title = s ? s.textContent.replace(/\s+/g, ' ').trim().slice(0, 100) : '';
    if (title) track('accordion_open', { accordion_title: title });
  }, true);

  // --- collection filters + gift card amount ----------------------------------------------------------------
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    var form = el.form || el.closest('form');
    if (form && /^FacetFiltersForm/.test(form.id || '') && (/^filter\./.test(el.name) || el.name === 'sort_by')) {
      if (el.type === 'checkbox' && !el.checked) return;
      var label = el.getAttribute('aria-label') || el.value;
      track('collection_filter', { filter_name: el.name, filter_value: String(label).slice(0, 100) });
      return;
    }
    if (cfg.pageType === 'gift_card' && el.type === 'radio' && el.checked && el.closest('variant-picker, .variant-picker')) {
      track('gift_card_amount_select', { gift_amount: el.value });
    }
  }, true);

  function onReady() {
    flushNext();
    checkPending();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
